import { supabase } from "../supabaseClient";
import { fetchStatsAndDownloads } from "./fetchStatsAndDownloads";

export const handleDownload = async ({
  url,
  user,
  stats,
  usedToday,
  setLoading,
  setDownloadLink,
  setShowModal,
  setStats,
  setDownloadHistory,
  setUsedToday,
  setErrorModalMessage,
  setShowErrorModal,
}) => {
  if (!url.trim()) return;

  setLoading(true);
  setDownloadLink("");
  setShowModal(false);

  const today = new Date();
  const expiryDate = new Date(stats.expires_at);
  if (today > expiryDate) {
    setErrorModalMessage("Your subscription has expired.");
    setShowErrorModal(true);
    setLoading(false);
    return;
  }

  if (usedToday >= stats.daily_limit || stats.daily_remaining <= 0) {
    setErrorModalMessage("You have reached your daily download limit.");
    setShowErrorModal(true);
    setLoading(false);
    return;
  }

  if (stats.total_downloaded >= stats.maximum) {
    setErrorModalMessage("You have reached your total download limit.");
    setShowErrorModal(true);
    setLoading(false);
    return;
  }

  try {
    const response = await fetch(
      "https://envato-elements-downloader-api1.p.rapidapi.com/api",
      {
        method: "POST",
        headers: {
          "x-rapidapi-key": process.env.REACT_APP_RAPIDAPI_KEY,
          "x-rapidapi-host": process.env.REACT_APP_RAPIDAPI_HOST,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ urls: [url] }),
      }
    );

    const data = await response.json();
    const link = data?.download_links?.[0]?.download_url;

    if (!link) {
      setErrorModalMessage("No download link returned. Please try again.");
      setShowErrorModal(true);
      return;
    }

    setDownloadLink(link);
    setShowModal(true);

    await supabase.from("downloads").insert([
      {
        user_id: user.id,
        url,
        status: "success",
      },
    ]);

    const { data: currentStats, error: fetchErr } = await supabase
      .from("user_stats")
      .select("total_downloaded, daily_remaining")
      .eq("id", user.id)
      .single();

    if (fetchErr) {
      console.error("Failed to fetch stats:", fetchErr.message);
    } else {
      const { total_downloaded, daily_remaining } = currentStats;
      await supabase
        .from("user_stats")
        .update({
          total_downloaded: total_downloaded + 1,
          daily_remaining: daily_remaining > 0 ? daily_remaining - 1 : 0,
        })
        .eq("id", user.id);
    }

    await fetchStatsAndDownloads(
      user,
      setStats,
      setDownloadHistory,
      setUsedToday
    );
  } catch (error) {
    console.error("Download error:", error);
    setErrorModalMessage("Download failed. Please try again.");
    setShowErrorModal(true);
  } finally {
    setLoading(false);
  }
};
